import HomeTemp from "../templates/HomeTemp";

const Home = () => <HomeTemp />;

export default Home;